import useDashboardContext from 'contexts/dashboard.context';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTE_KEYS } from 'utils/constants';

const NewMealXlsIndex = () => {
  const navigate = useNavigate();
  const { routePrefix } = useDashboardContext();
  useEffect(() => {
    navigate(`${routePrefix}/${ROUTE_KEYS.NEW_MEAL_XLS}/${ROUTE_KEYS.NEW_MEAL_XLS_UPLOAD}`, {
      replace: true
    });
  }, []);

  return <div />;
};

export default NewMealXlsIndex;
